import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import './App.css';
import Topbar from './components/Topbar';
import Bar from './components/Bar';
import Sfooter from "./components/Sfooter";
import Home from './components/Home';
import AboutUs from './components/About';
import Pricing from './components/pricing';
import Projects from './components/projects';
import Form from "./components/Form";
import Another from './components/Another';
import Whatsapp from './components/Whatsapp';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          element={
            <>
              <Topbar />
              <Bar />
              <Outlet />
              <Whatsapp />
              <Sfooter />
            </>
          }
        >
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Form />} />
          <Route path="/service" element={<Another />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
